var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showInitial)?_c('span',{staticClass:"d-flex align-items-center"},[(_vm.isSaved)?_c('CircleCheck',{staticClass:"text-success ml-2 mr-2",attrs:{"size":14}}):_c('Clock',{staticClass:"ml-2 mr-2",attrs:{"size":14}}),_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.savedText)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }